import { deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../../config';

// 辞書の変換履歴を1件削除する（誤って記録した履歴の削除用）。
// 変換履歴は学習させたデータそのものなので物理削除でよい（マスタの照合履歴削除と同じ）。
export const deleteDictionaryHistory = async (
  dictionaryId: string,
  historyId: string,
): Promise<void> => {
  await deleteDoc(doc(db, 'dictionaries', dictionaryId, 'conversion_histories', historyId));
};
